import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { SignContract } from './SignContract'
import { LoadingPage } from 'src/pages/LoadingPage'

const SignContractPageComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep)

  if (!currentStep) {
    return <LoadingPage flow="client" />
  }

  return <SignContract key={currentStep.id} currentStepId={currentStep.id} />
}

export const SignContractPage = memo(SignContractPageComponent)
